import { useDebounceWindowEventListener } from '@vista-digital/react-tools';
import { useState } from 'react';
const defaultDebounceInterval = 166;
/**
 * Listens to window resizing and returns the width.
 */
export const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useDebounceWindowEventListener(() => setWidth(window.innerWidth), 'resize', defaultDebounceInterval);
    return width;
};
//# sourceMappingURL=use-window-width.js.map